<template>
  <div>
    <f7-list style="margin: 0px 0px 0px 0px;">
      <f7-list-item
        :link="`/stores/${storeId}/menu-drafts/${menuDraftVariation}/questions/${questionId}/question-default-value-actions`"
        :title="`預設值: ${defaultValue}`" />
    </f7-list>

    <option-manager :storeId="storeId" :menuDraftVariation="menuDraftVariation" :questionId="questionId" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import OptionManager from '../OptionsManager'
export default {
  props: {
    storeId: String,
    menuDraftVariation: String,
    questionId: String
  },
  computed: {
    ...mapState('menuDraftModule', ['currentDraft']),
    question () { return this.currentDraft.questions[this.questionId] },
    defaultValue () {
      return this.question.defaultValue
        ? this.currentDraft.options[this.question.defaultValue].title
        : '無'
    }
  },
  components: {
    OptionManager
  }
}
</script>
